var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { collection, doc, getDoc, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { DateFormat } from "@tiffin/core";
import { auth, db } from "../firebase";
import moment from "moment";
export function fetchPastDays(numberOfDays, offset) {
    if (offset === void 0) { offset = 0; }
    return new Promise(function (resolve, reject) {
        if (auth.currentUser) {
            var dailyRef = collection(doc(collection(db, "metrics"), auth.currentUser.uid), "daily");
            var dailyQuery = query(dailyRef, where("date", ">", moment().startOf('day').subtract(numberOfDays + offset, 'days').format(DateFormat)), where("date", "<=", moment().startOf('day').subtract(offset, 'days').format(DateFormat)), orderBy("date", "asc"));
            getDocs(dailyQuery).then(function (querySnapshot) {
                var records = [];
                querySnapshot.forEach(function (doc) {
                    records.push(__assign({}, doc.data()));
                });
                resolve(records);
            });
        }
    });
}
export function fetchItemsMetrics(top, type) {
    return new Promise(function (resolve, reject) {
        if (auth.currentUser) {
            var dailyRef = collection(doc(collection(db, "metrics"), auth.currentUser.uid), "items");
            var dailyQuery = void 0;
            if (type === "quantity") {
                dailyQuery = query(dailyRef, orderBy("count", "desc"), limit(top));
            }
            else if (type === "revenue") {
                dailyQuery = query(dailyRef, orderBy("revenue", "desc"), limit(top));
            }
            getDocs(dailyQuery).then(function (querySnapshot) {
                var records = [];
                querySnapshot.forEach(function (doc) {
                    records.push(__assign({}, doc.data()));
                });
                resolve(records);
            });
        }
    });
}
export function fetchMetrics() {
    var _this = this;
    return new Promise(function (resolve, reject) {
        if (auth.currentUser) {
            var metricsRef = doc(db, "metrics", auth.currentUser.uid);
            getDoc(metricsRef).then(function (docSnap) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (docSnap.exists()) {
                        resolve(docSnap.data());
                    }
                    else {
                        resolve(null);
                    }
                    return [2 /*return*/];
                });
            }); });
        }
        else {
            reject("User is not authenticated");
        }
    });
}
